import { IonIcon, IonItem, IonLabel } from "@ionic/react";
import {
  chatboxEllipsesOutline,
  fingerPrintOutline,
  logoWhatsapp,
  toggleSharp,
} from "ionicons/icons";

import { Category } from "../../../@types/Category";

export const FileTypesListItem = ({ category }: { category: Category }) => {
  return (
    <IonItem
      routerLink={`/app/tic/tipos-de-archivos/detalle/${category.id}`}
      class="ion-margin-bottom"
      lines="none"
      detail
    >
      <IonLabel>
        <h2 style={{ fontWeight: 500 }} className="ion-text-wrap">
          {category.name.toUpperCase()}
        </h2>
        {category.isSignable && <IonIcon icon={fingerPrintOutline} slot="start" />}{" "}
        {category.sendMessageWhatsApp && <IonIcon icon={logoWhatsapp} slot="start" />}{" "}
        {category.sendMessageSMS && <IonIcon icon={chatboxEllipsesOutline} slot="start" />}
      </IonLabel>
      {category.enabled && <IonIcon icon={toggleSharp} color="success" />}
      {!category.enabled && (
        <IonIcon icon={toggleSharp} color="medium" style={{ transform: "rotate(180deg)" }} />
      )}
    </IonItem>
  );
};
